const organization = `
query organizations($skip: Int, $limit: Int, $sort: sortInput, $where:organizationWhereInput){
    organizations(skip: $skip, limit: $limit, sort: $sort, where:$where){
        list {
            id
            name
            isActive
            createdAt
            internalCode
            source
        }
        totalCount
    }
}`

const organizations = `
query organizations($skip: Int, $limit: Int, $sort: sortInput, $where:organizationWhereInput){
    organizations(skip: $skip, limit: $limit, sort: $sort, where:$where){
        list {
            id
            name
            isActive
            createdAt
            internalCode
            source
        }
        totalCount
    }
}`

const createOrganization = `
mutation createOrganization($createOrganizationInput:createOrganizationInput!){
    createOrganization(createOrganizationInput: $createOrganizationInput){
    status
    errors
    createdStatus{
      id
    }
  }
}
`
const updateOrganization = `
mutation updateOrganization($id: String!, $updateOrganizationInput:updateOrganizationInput!){
    updateOrganization(id: $id, updateOrganizationInput: $updateOrganizationInput){
    status
    errors
  }
}
`
const deleteOrganization = `
mutation deleteOrganization($id: String!){
    deleteEntity(id: $id){
    status
    errors
  }
}
`

const query = {
	organization,
	organizations
}

const mutation = {
	createOrganization,
	updateOrganization,
	deleteOrganization
}

export { query, mutation }
